import React from 'react';
import styled from 'styled-components';
import BannerItem from './BannerItem';

const ListWrap = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  grid-gap: 8px;
  padding-bottom: 24px;
`;

type Props = {
  banners?: Ibanner[];
};
function BannerList({ banners }: Props) {
  if (!banners?.length) return null;

  return (
    <ListWrap>
      {banners.map((banner) => (
        <BannerItem key={banner.id || banner.name} data={banner} />
      ))}
    </ListWrap>
  );
}

export default BannerList;
